import React from "react";

const leads = [
  { name: "Müller GmbH", source: "Google Maps", rating: "★★★★★" },
  { name: "TechVision AG", source: "CSV Import", rating: "★★★★☆" },
  { name: "Apex Solutions", source: "Web Form", rating: "★★★★★" },
  { name: "BrightCore Ltd.", source: "Google Maps", rating: "★★★☆☆" },
];

const sourceColors: Record<string, string> = {
  "Google Maps": "bg-red-900/40 text-red-400 border-red-800/50",
  "CSV Import": "bg-blue-900/40 text-blue-400 border-blue-800/50",
  "Web Form": "bg-purple-900/40 text-purple-400 border-purple-800/50",
};

export const SkeletonFour = () => {
  return (
    <div className="relative flex py-8 px-2 h-full">
      <div className="w-full p-5 mx-auto bg-neutral-950 shadow-2xl group rounded-2xl border border-neutral-800">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-purple-500" />
            <span className="text-[10px] text-neutral-400 font-medium uppercase tracking-wider">
              Lead Discovery
            </span>
          </div>
          <span className="text-[10px] text-neutral-500">42 new leads</span>
        </div>

        {/* Lead list */}
        <div className="space-y-2 mb-4">
          {leads.map((lead, i) => (
            <div
              key={i}
              className="flex items-center justify-between p-2.5 bg-neutral-900 rounded-xl border border-neutral-800"
            >
              <div className="flex items-center gap-2.5 min-w-0">
                <div className="w-6 h-6 rounded-lg bg-neutral-800 flex items-center justify-center flex-shrink-0">
                  <span className="text-[9px] font-bold text-neutral-400">
                    {lead.name.charAt(0)}
                  </span>
                </div>
                <div className="min-w-0">
                  <p className="text-[11px] font-medium text-neutral-200 truncate">
                    {lead.name}
                  </p>
                  <span
                    className={`text-[9px] px-1.5 py-0.5 rounded-md border ${sourceColors[lead.source]}`}
                  >
                    {lead.source}
                  </span>
                </div>
              </div>
              <span className="text-[10px] text-yellow-500 flex-shrink-0 ml-2">
                {lead.rating}
              </span>
            </div>
          ))}
        </div>

        {/* Import button */}
        <div className="w-full h-9 rounded-xl bg-green-700 hover:bg-green-600 transition-colors flex items-center justify-center gap-2 cursor-pointer">
          <svg
            className="w-3.5 h-3.5 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
            />
          </svg>
          <span className="text-[11px] font-semibold text-white">
            Import 42 leads into pipeline
          </span>
        </div>
      </div>
    </div>
  );
};
